import { useContext } from "react";
import { createBrowserRouter } from "react-router";
import { RouterProvider } from "react-router/dom";

// --- Core/Global Imports ---
import { AppContext } from "App";
import { RevenueDashboardWorkspace } from "components/Dashboard/RevenueDashboardWorkspace";
import { default as EmptyWorkspace } from "components/Workspaces/EmptyWorkspace";
import { accountRoutes } from "routes/accountRoutes.jsx";
import { arcPlcRoutes } from "routes/arcPlcRoutes.jsx";
import { brokerRoutes } from "routes/brokerRoutes.jsx";
import { budgetRoutes } from "routes/budgetRoutes.jsx";
import { calculatorRoutes } from "routes/calculatorRoutes.jsx";
import { financialRoutes } from "routes/financialRoutes.jsx";
import { insuranceRoutes } from "routes/insuranceRoutes.jsx";
import { lenderRoutes } from "routes/lenderRoutes.jsx";
import { marketingRoutes } from "routes/marketingRoutes.jsx";
import { reportsRoutes } from "routes/reportsRoutes.jsx";
import { systemRoutes } from "routes/systemRoutes.jsx";
import { tilleyRoutes } from "routes/tilleyRoutes.jsx";
import { userGrantRoutes } from "routes/userGrantRoutes.jsx";
// --- Import Route Arrays ---
import { vaultRoutes } from "routes/vaultRoutes.jsx";

import NotFound from "./NotFound";
import RouteLayout, { RouteErrorLayout } from "./RouteLayout";

export default function NavigationRoutes() {
  const { globalState } = useContext(AppContext);

  const coreRoutes = [
    // Catch-all route for undefined paths
    {
      path: "*",
      element: <RouteLayout />,
      children: [{ index: true, element: <NotFound /> }],
      errorElement: <RouteErrorLayout errorTitle="Page Not Found" />,
    },
    // Root route
    {
      path: "/",
      element: <RouteLayout />,
      children: [
        {
          index: true,
          element: globalState.user_role === "PRODUCER" ? <RevenueDashboardWorkspace /> : <EmptyWorkspace />,
        },
      ],
      errorElement: <RouteErrorLayout errorTitle="Tilley" />,
    },
  ];

  const router = createBrowserRouter(
    [
      ...coreRoutes,
      ...vaultRoutes,
      ...budgetRoutes,
      ...arcPlcRoutes,
      ...insuranceRoutes,
      ...accountRoutes,
      ...financialRoutes,
      ...reportsRoutes,
      ...calculatorRoutes,
      ...lenderRoutes,
      ...userGrantRoutes,
      ...marketingRoutes,
      ...brokerRoutes,
      ...systemRoutes,
      ...tilleyRoutes,
    ],
    {
      future: {
        v7_relativeSplatPath: true,
        v7_fetcherPersist: true,
        v7_normalizeFormMethod: true,
        v7_partialHydration: true,
        v7_skipActionErrorRevalidation: true,
      },
    }
  );

  return (
    <>
      <RouterProvider
        router={router}
        future={{
          v7_startTransition: true,
        }}
      />
    </>
  );
}
